import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { DocumentType } from '@/schema'

interface FileTypeSelectProps {
  value?: string
  onChange: (value: string) => void
  disabled?: boolean
}

export const FileTypeSelect: React.FC<FileTypeSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation()

  const getDisplayLabel = (val?: string) => {
    switch (val) {
      case DocumentType.TABLE:
        return t('fileUpload.fileType.table')
      case DocumentType.FIGURE:
        return t('fileUpload.fileType.figure')
      case DocumentType.LIST:
        return t('fileUpload.fileType.listing')
      default:
        return t('fileUpload.fileType.selectType')
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="text"
          disabled={disabled}
          className="justify-start w-full h-full px-3 py-2 pl-0 text-sm font-normal rounded-none hover:bg-transparent"
          trailingIcon={<ChevronDown size={20} className="text-gray-400" />}
        >
          <span className="text-sm text-black text-foreground-fg-primary">
            {getDisplayLabel(value)}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="!w-[var(--radix-dropdown-menu-trigger-width)] !min-w-0 !max-w-none p-0"
      >
        <DropdownMenuItem
          onClick={() => onChange(DocumentType.TABLE)}
          className="cursor-pointer"
        >
          {t('fileUpload.fileType.table')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onChange(DocumentType.FIGURE)}
          className="cursor-pointer"
        >
          {t('fileUpload.fileType.figure')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onChange(DocumentType.LIST)}
          className="cursor-pointer"
        >
          {t('fileUpload.fileType.listing')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
